(function($, Drupal, once) {

  Drupal.behaviors.retain_mobile_nav = {
    attach: function (context, settings) {

      $('.header-mobile--bars a').off('click').on('click', function(){
        console.log('mobile header toggled')
        let body = $('body')

        if (body.hasClass('mobile-nav-open')) {
          body.removeClass('mobile-nav-open');
        } else {
          body.addClass('mobile-nav-open');
        }

        return false;
      });

      $(document).off('click.mobileNav').on('click.mobileNav', 'ul.menu li.menu-item > a, ul.menu li.menu-item > span', function(){
        if (!$('body').hasClass('mobile-nav-open')) return;

        let parent = $(this).parent();
        if (!parent.find('.menu_link_content').length) return;

        if (parent.hasClass('expanded')) {
          parent.removeClass('expanded');
          parent.find('.expanded').removeClass('expanded');
        } else {
          parent.addClass('expanded');
        }

        return false;
      });

      $('.product-menu--title').off('click').on('click', function(){
        let parent = $(this).parent();

        if (parent.hasClass('expanded')) {
          parent.removeClass('expanded');
          parent.find('.expanded').removeClass('expanded');
        } else {
          parent.addClass('expanded');
        }

        return false;
      });

      $('.solution-menu--title').off('click').on('click', function(){
        let parent = $(this).parent();

        if (parent.hasClass('expanded')) {
          parent.removeClass('expanded');
          parent.find('.expanded').removeClass('expanded');
        } else {
          parent.addClass('expanded');
        }

        return false;
      });
    }
  };

})(jQuery, Drupal, once)




